export const CURRENCY = '$'